import axiosInstance from "./axiosInstance";
import { catchError } from "../utils/errorHandler";

const orderTagService = {
  getTags: async () => {
    try {
      const response = await axiosInstance.get("task/v2/order-tags/");
      return { success: true, data: response.data.data };
    } catch (error) {
      await catchError(error);
      return { success: false };
    }
  },

  createTag: async (name, color) => {
    try {
      const response = await axiosInstance.post("task/v2/order-tags/", { name, color });
      return { success: true, data: response.data.data };
    } catch (error) {
      const msg = error?.response?.data?.message || "Failed to create tag";
      return { success: false, message: msg };
    }
  },

  updateTag: async (uid, name, color) => {
    try {
      const response = await axiosInstance.put(`task/v2/order-tags/${uid}/`, { name, color });
      return { success: true, data: response.data.data };
    } catch (error) {
      const msg = error?.response?.data?.message || "Failed to update tag";
      return { success: false, message: msg };
    }
  },

  deleteTag: async (uid) => {
    try {
      await axiosInstance.delete(`task/v2/order-tags/${uid}/`);
      return { success: true };
    } catch (error) {
      await catchError(error);
      return { success: false };
    }
  },

  assignTag: async (uid, taskKey) => {
    try {
      await axiosInstance.post(`task/v2/order-tags/${uid}/assign/${taskKey}/`);
      return { success: true };
    } catch (error) {
      await catchError(error);
      return { success: false };
    }
  },

  removeTag: async (uid, taskKey) => {
    try {
      await axiosInstance.delete(`task/v2/order-tags/${uid}/assign/${taskKey}/`);
      return { success: true };
    } catch (error) {
      await catchError(error);
      return { success: false };
    }
  },

  getOrdersByTag: async (uid, page = 1, pageSize = 20) => {
    try {
      const response = await axiosInstance.get(`task/v2/order-tags/by-tag/${uid}/`, {
        params: { page, page_size: pageSize },
      });
      return { success: true, data: response.data.data };
    } catch (error) {
      await catchError(error);
      return { success: false };
    }
  },

  getTaggedTaskKeys: async () => {
    try {
      const response = await axiosInstance.get("task/v2/order-tags/tagged-task-keys/");
      return { success: true, data: response.data.data };
    } catch (error) {
      await catchError(error);
      return { success: false, data: [] };
    }
  },

  getTagsForTask: async (taskKey) => {
    try {
      const response = await axiosInstance.get(`task/v2/order-tags/for-task/${taskKey}/`);
      return { success: true, data: response.data.data };
    } catch (error) {
      await catchError(error);
      return { success: false };
    }
  },
};

export default orderTagService;
